<template>
    <el-select
        v-model="model"
        class="sound-select"
        :placeholder="placeholder"
        :size="size"
        :class="selectClass"
        :filterable="filterable"
        @visible-change="dropdownVisibleChange"
    >
        <el-option
            v-bind="option"
            v-for="option in options"
            :key="option.value"
            :value="option.value"
            :label="option.label"
        >
            <div
                v-if="option.sound"
                class="flex items-center flex-grow"
            >
                <el-tooltip
                    effect="dark"
                    :content="option.label"
                    placement="top"
                    :disabled="!isTruncated">
                    <span class="sound-label" v-ellipsis-check>{{ option.label }}</span>
                </el-tooltip>
                <SoundSelector
                    class="sound-selector"
                    :ref="`sound-${uid}-${option.soundId}`"
                    :sound-id="option.soundId"
                    :src="option.sound"
                />
            </div>
            <div v-else>
                {{ option.label }}
            </div>
        </el-option>
    </el-select>
</template>

<script>
import SoundSelector from "@/views/DashboardSettings/LayoutManagement/components/SoundSelector.vue";
import {Option, Select} from "element-ui";

export default {
    name: "SoundSelect",
    components: {
        SoundSelector,
        [Option.name]: Option,
        [Select.name]: Select,
    },
    props: {
        value: {
            type: [Object, String, Number]
        },
        placeholder: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'small'
        },
        filterable: {
            type: Boolean,
            default: true
        },
        selectClass: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: []
        }
    },
    data () {
        return {
            isTruncated: false
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        uid () {
            return this._uid
        }
    },
    methods: {
        dropdownVisibleChange (status) {
            if (!status) {
                this.options.forEach(option => {
                    const ref = `sound-${this.uid}-${option.soundId}`
                    const refEl = Array.isArray(this.$refs[ref]) ? this.$refs[ref][0] : this.$refs[ref]
                    if (refEl) {
                        refEl.stop()
                    }
                })
            }
        }
    }
}
</script>

<style scoped>
.sound-label {
    @apply truncate;
    flex-grow: 1;
    max-width: 350px;
}
.sound-selector {
    @apply ml-3;
    min-width: 250px;
    width: auto;
}
[dir='rtl'] {
    .sound-selector {
        @apply mr-3;
        margin-left: unset;
    }
}
</style>